import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "manage-documents" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Gerenciar documentos", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "header" }
const _hoisted_6 = {
  class: "search",
  for: "search-doc"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4 4L16 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16 4L4 16",
  stroke: "#079F72",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "filters" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M8 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3.5 9.08984H20.5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 13.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 16.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 13.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 16.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 13.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 16.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M16.0399 3.01976L8.15988 10.8998C7.85988 11.1998 7.55988 11.7898 7.49988 12.2198L7.06988 15.2298C6.90988 16.3198 7.67988 17.0798 8.76988 16.9298L11.7799 16.4998C12.1999 16.4398 12.7899 16.1398 13.0999 15.8398L20.9799 7.95976C22.3399 6.59976 22.9799 5.01976 20.9799 3.01976C18.9799 1.01976 17.3999 1.65976 16.0399 3.01976Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.9102 4.1499C15.5802 6.5399 17.4502 8.4099 19.8502 9.0899",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.9284 2.1001L5.99844 10.0001M5.39844 2.1001H18.5984C19.6984 2.1001 20.5984 3.0001 20.5984 4.1001V6.3001C20.5984 7.1001 20.0984 8.1001 19.5984 8.6001L15.2984 12.4001C14.6984 12.9001 14.2984 13.9001 14.2984 14.7001V19.0001C14.2984 19.6001 13.8984 20.4001 13.3984 20.7001L11.9984 21.6001C10.6984 22.4001 8.89844 21.5001 8.89844 19.9001V14.6001C8.89844 13.9001 8.49844 13.0001 8.09844 12.5001L4.29844 8.5001C3.79844 8.0001 3.39844 7.1001 3.39844 6.5001V4.2001C3.39844 3.0001 4.29844 2.1001 5.39844 2.1001Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M9 11V17L11 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9 17L7 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10H18C15 10 14 9 14 6V2L22 10Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "order" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_23 = { class: "order-filter" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "order-filter-asc",
  class: "asc"
}, " Mais novos ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "order-filter-desc",
  class: "desc"
}, " Mais antigos ", -1)
const _hoisted_26 = {
  key: 0,
  class: "documents"
}
const _hoisted_27 = { class: "documents-title doc-grid" }
const _hoisted_28 = {
  for: "all-docs",
  class: "check"
}
const _hoisted_29 = ["checked"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "11",
    viewBox: "0 0 13 11",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.06761 9.95167C4.94632 10.0727 4.78194 10.1407 4.61057 10.1407C4.43919 10.1407 4.27482 10.0727 4.15352 9.95167L0.501349 6.2995C0.411146 6.20946 0.339583 6.10251 0.290756 5.98479C0.241929 5.86706 0.216797 5.74086 0.216797 5.61341C0.216797 5.48596 0.241929 5.35976 0.290756 5.24203C0.339583 5.1243 0.411146 5.01736 0.501349 4.92732L0.958393 4.47132C1.14038 4.2894 1.38716 4.1872 1.64448 4.1872C1.9018 4.1872 2.14858 4.2894 2.33057 4.47132L4.61057 6.74923L10.7671 0.592713C10.9491 0.410791 11.1959 0.308594 11.4532 0.308594C11.7105 0.308594 11.9573 0.410791 12.1393 0.592713L12.5963 1.04976C12.6865 1.1398 12.7581 1.24674 12.8069 1.36447C12.8557 1.48219 12.8809 1.60839 12.8809 1.73584C12.8809 1.86329 12.8557 1.98949 12.8069 2.10722C12.7581 2.22495 12.6865 2.33189 12.5963 2.42193L5.06761 9.95167Z",
      fill: "white"
    })
  ])
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Titulo e Origem")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Vencimento")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Responsável")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Status")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Ações")
], -1)
const _hoisted_36 = {
  key: 0,
  class: "documents-full"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18 6L6 18",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 6L18 18",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h1", null, "Ações em massa", -1)
const _hoisted_41 = { class: "actions" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, "baixar todos os anexos", -1)
const _hoisted_43 = {
  style: {"width":"24px"},
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<g id=\"vuesax/linear/frame\"><g id=\"frame\"><path id=\"Vector\" d=\"M16.4405 8.90039C20.0405 9.21039 21.5105 11.0604 21.5105 15.1104V15.2404C21.5105 19.7104 19.7205 21.5004 15.2505 21.5004H8.74047C4.27047 21.5004 2.48047 19.7104 2.48047 15.2404V15.1104C2.48047 11.0904 3.93047 9.24039 7.47047 8.91039\" fill=\"none\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M12 2V14.88\" fill=\"none\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_3\" d=\"M15.3504 12.6504L12.0004 16.0004L8.65039 12.6504\" fill=\"none\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></g>", 1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["for"]
const _hoisted_47 = ["id", "checked", "onChange"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "11",
    viewBox: "0 0 13 11",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.06761 9.95167C4.94632 10.0727 4.78194 10.1407 4.61057 10.1407C4.43919 10.1407 4.27482 10.0727 4.15352 9.95167L0.501349 6.2995C0.411146 6.20946 0.339583 6.10251 0.290756 5.98479C0.241929 5.86706 0.216797 5.74086 0.216797 5.61341C0.216797 5.48596 0.241929 5.35976 0.290756 5.24203C0.339583 5.1243 0.411146 5.01736 0.501349 4.92732L0.958393 4.47132C1.14038 4.2894 1.38716 4.1872 1.64448 4.1872C1.9018 4.1872 2.14858 4.2894 2.33057 4.47132L4.61057 6.74923L10.7671 0.592713C10.9491 0.410791 11.1959 0.308594 11.4532 0.308594C11.7105 0.308594 11.9573 0.410791 12.1393 0.592713L12.5963 1.04976C12.6865 1.1398 12.7581 1.24674 12.8069 1.36447C12.8557 1.48219 12.8809 1.60839 12.8809 1.73584C12.8809 1.86329 12.8557 1.98949 12.8069 2.10722C12.7581 2.22495 12.6865 2.33189 12.5963 2.42193L5.06761 9.95167Z",
      fill: "white"
    })
  ])
], -1)
const _hoisted_49 = { class: "title" }
const _hoisted_50 = {
  key: 0,
  class: "tag black"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  class: /*#__PURE__*/_normalizeClass({ exceptions: true })
}
const _hoisted_53 = {
  key: 0,
  class: "exception"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.99935 18.3332C14.5827 18.3332 18.3327 14.5832 18.3327 9.99984C18.3327 5.4165 14.5827 1.6665 9.99935 1.6665C5.41601 1.6665 1.66602 5.4165 1.66602 9.99984C1.66602 14.5832 5.41601 18.3332 9.99935 18.3332Z",
    stroke: "#E1793E",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 6.6665V10.8332",
    stroke: "#E1793E",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.99609 13.3335H10.0036",
    stroke: "#E1793E",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_55 = {
  for: "",
  class: "actions"
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M15.5799 11.9999C15.5799 13.9799 13.9799 15.5799 11.9999 15.5799C10.0199 15.5799 8.41992 13.9799 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C13.9799 8.41992 15.5799 10.0199 15.5799 11.9999Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      d: "M11.9998 20.2702C15.5298 20.2702 18.8198 18.1902 21.1098 14.5902C22.0098 13.1802 22.0098 10.8102 21.1098 9.40021C18.8198 5.80021 15.5298 3.72021 11.9998 3.72021C8.46984 3.72021 5.17984 5.80021 2.88984 9.40021C1.98984 10.8102 1.98984 13.1802 2.88984 14.5902C5.17984 18.1902 8.46984 20.2702 11.9998 20.2702Z",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6",
  height: "26",
  viewBox: "0 0 6 26",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    stroke: "none",
    cx: "3",
    cy: "3",
    r: "3",
    transform: "rotate(-90 3 3)"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    stroke: "none",
    cx: "3",
    cy: "13",
    r: "3",
    transform: "rotate(-90 3 13)"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    stroke: "none",
    cx: "3",
    cy: "23",
    r: "3",
    transform: "rotate(-90 3 23)"
  })
], -1)
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<p>Concluir</p><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"10\" viewBox=\"0 0 13 10\" fill=\"none\"><g clip-path=\"url(#clip0_366_3431)\"><path d=\"M4.6487 9.24519C4.53246 9.36121 4.37493 9.42638 4.2107 9.42638C4.04646 9.42638 3.88894 9.36121 3.7727 9.24519L0.272696 5.74519C0.186251 5.6589 0.11767 5.55641 0.0708778 5.44359C0.0240854 5.33077 0 5.20983 0 5.08769C0 4.96555 0.0240854 4.84461 0.0708778 4.73178C0.11767 4.61896 0.186251 4.51648 0.272696 4.43019L0.710696 3.99319C0.885096 3.81885 1.1216 3.72091 1.3682 3.72091C1.61479 3.72091 1.8513 3.81885 2.0257 3.99319L4.2107 6.17619L10.1107 0.276188C10.2851 0.101846 10.5216 0.00390625 10.7682 0.00390625C11.0148 0.00390625 11.2513 0.101846 11.4257 0.276188L11.8637 0.714188C11.9501 0.800475 12.0187 0.902962 12.0655 1.01578C12.1123 1.12861 12.1364 1.24955 12.1364 1.37169C12.1364 1.49383 12.1123 1.61477 12.0655 1.72759C12.0187 1.84041 11.9501 1.9429 11.8637 2.02919L4.6487 9.24519Z\" stroke=\"none\"></path></g><defs><clipPath id=\"clip0_366_3431\"><rect width=\"12.141\" height=\"9.427\" fill=\"white\"></rect></clipPath></defs></svg>", 2)
const _hoisted_63 = [
  _hoisted_61
]
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<p>Transferir</p><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><path d=\"M8.33268 5.00033H11.666C13.3327 5.00033 13.3327 4.16699 13.3327 3.33366C13.3327 1.66699 12.4993 1.66699 11.666 1.66699H8.33268C7.49935 1.66699 6.66602 1.66699 6.66602 3.33366C6.66602 5.00033 7.49935 5.00033 8.33268 5.00033Z\" fill=\"none\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.6667 18.3329H7.5C3.33333 18.3329 2.5 16.6663 2.5 13.3329V8.33294C2.5 4.53294 3.89167 3.49961 6.66667 3.34961\" fill=\"none\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M13.334 3.34961C16.109 3.49961 17.5007 4.52461 17.5007 8.33294V12.4996\" fill=\"none\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M17.5 15.833V18.333H15\" fill=\"none\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M12.5 13.333L17.4667 18.2997\" fill=\"none\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg>", 2)
const _hoisted_66 = [
  _hoisted_64
]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<p>Baixar anexo</p><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\"><g clip-path=\"url(#clip0_366_3443)\"><path d=\"M7.5 9.16699V14.167L9.16667 12.5003\" fill=\"none\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M7.50065 14.1667L5.83398 12.5\" fill=\"none\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M18.3327 8.33366V12.5003C18.3327 16.667 16.666 18.3337 12.4993 18.3337H7.49935C3.33268 18.3337 1.66602 16.667 1.66602 12.5003V7.50033C1.66602 3.33366 3.33268 1.66699 7.49935 1.66699H11.666\" fill=\"none\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M18.3327 8.33366H14.9993C12.4993 8.33366 11.666 7.50033 11.666 5.00033V1.66699L18.3327 8.33366Z\" fill=\"none\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_366_3443\"><rect width=\"20\" height=\"20\" fill=\"white\"></rect></clipPath></defs></svg>", 2)
const _hoisted_70 = [
  _hoisted_68
]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("p", null, "Reabrir", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.166 18.333H5.83268C2.49935 18.333 1.66602 17.4997 1.66602 14.1663V12.4997C1.66602 9.16634 2.49935 8.33301 5.83268 8.33301H14.166C17.4993 8.33301 18.3327 9.16634 18.3327 12.4997V14.1663C18.3327 17.4997 17.4993 18.333 14.166 18.333Z",
    fill: "none",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 8.33366V6.66699C5 3.90866 5.83333 1.66699 10 1.66699C13.75 1.66699 15 3.33366 15 5.83366",
    fill: "none",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.99935 15.4167C11.1499 15.4167 12.0827 14.4839 12.0827 13.3333C12.0827 12.1827 11.1499 11.25 9.99935 11.25C8.84876 11.25 7.91602 12.1827 7.91602 13.3333C7.91602 14.4839 8.84876 15.4167 9.99935 15.4167Z",
    fill: "none",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = {
  key: 1,
  class: "pagination"
}
const _hoisted_75 = ["disabled", "onClick"]
const _hoisted_76 = {
  key: 1,
  class: "no-options"
}
const _hoisted_77 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"85\" height=\"84\" viewBox=\"0 0 25 24\" fill=\"none\"><path opacity=\"0.4\" d=\"M21 10.19H18.11C15.74 10.19 13.81 8.26 13.81 5.89V3C13.81 2.45 13.36 2 12.81 2H8.57C5.49 2 3 4 3 7.57V16.43C3 20 5.49 22 8.57 22H16.43C19.51 22 22 20 22 16.43V11.19C22 10.64 21.55 10.19 21 10.19Z\" fill=\"#171717\"></path><path d=\"M16.2999 2.20999C15.8899 1.79999 15.1799 2.07999 15.1799 2.64999V6.13999C15.1799 7.59999 16.4199 8.80999 17.9299 8.80999C18.8799 8.81999 20.1999 8.81999 21.3299 8.81999C21.8999 8.81999 22.1999 8.14999 21.7999 7.74999C20.3599 6.29999 17.7799 3.68999 16.2999 2.20999Z\" fill=\"#171717\"></path><path d=\"M14 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25H14C14.41 12.25 14.75 12.59 14.75 13C14.75 13.41 14.41 13.75 14 13.75Z\" fill=\"#171717\"></path><path d=\"M12 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H12C12.41 16.25 12.75 16.59 12.75 17C12.75 17.41 12.41 17.75 12 17.75Z\" fill=\"#171717\"></path></svg><h1>Sem documentos para gerenciar no momento</h1>", 2)
const _hoisted_79 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M8 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M16 2V5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3.5 9.08984H20.5\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 13.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M15.6937 16.7002H15.7027\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 13.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M11.9945 16.7002H12.0035\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 13.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M8.29529 16.7002H8.30427\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.16602 1.6665H7.49935C3.33268 1.6665 1.66602 3.33317 1.66602 7.49984V12.4998C1.66602 16.6665 3.33268 18.3332 7.49935 18.3332H12.4993C16.666 18.3332 18.3327 16.6665 18.3327 12.4998V10.8332",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M13.3675 2.51688L6.80088 9.08354C6.55088 9.33354 6.30088 9.82521 6.25088 10.1835L5.89254 12.6919C5.75921 13.6002 6.40088 14.2335 7.30921 14.1085L9.81754 13.7502C10.1675 13.7002 10.6592 13.4502 10.9175 13.2002L17.4842 6.63354C18.6175 5.50021 19.1509 4.18354 17.4842 2.51688C15.8175 0.850211 14.5009 1.38354 13.3675 2.51688Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12.4258 3.4585C12.9841 5.45016 14.5424 7.0085 16.5424 7.57516",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M9 11V17L11 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9 17L7 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10H18C15 10 14 9 14 6V2L22 10Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.9284 2.1001L5.99844 10.0001M5.39844 2.1001H18.5984C19.6984 2.1001 20.5984 3.0001 20.5984 4.1001V6.3001C20.5984 7.1001 20.0984 8.1001 19.5984 8.6001L15.2984 12.4001C14.6984 12.9001 14.2984 13.9001 14.2984 14.7001V19.0001C14.2984 19.6001 13.8984 20.4001 13.3984 20.7001L11.9984 21.6001C10.6984 22.4001 8.89844 21.5001 8.89844 19.9001V14.6001C8.89844 13.9001 8.49844 13.0001 8.09844 12.5001L4.29844 8.5001C3.79844 8.0001 3.39844 7.1001 3.39844 6.5001V4.2001C3.39844 3.0001 4.29844 2.1001 5.39844 2.1001Z",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = /*#__PURE__*/_createStaticVNode("<figure><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M9 11V17L11 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M9 17L7 15\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M22 10H18C15 10 14 9 14 6V2L22 10Z\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></figure>", 1)
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = /*#__PURE__*/_createElementVNode("button", null, [
  /*#__PURE__*/_createElementVNode("figure", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M7 7L17 17M7 17L17 7",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ])
  ])
], -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("h1", null, "Filtro por data", -1)
const _hoisted_91 = { class: "dates" }
const _hoisted_92 = { class: "to" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "De"),
  /*#__PURE__*/_createTextVNode(" (data inicial)")
], -1)
const _hoisted_94 = { class: "from" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Até"),
  /*#__PURE__*/_createTextVNode(" (data final)")
], -1)
const _hoisted_96 = { class: "action" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("h1", null, "Filtros", -1)
const _hoisted_98 = { class: "filters" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("h2", null, "Por status", -1)
const _hoisted_100 = ["for"]
const _hoisted_101 = ["id", "value", "onUpdate:modelValue"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_103 = { for: "exception" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("p", null, "Exceção", -1)
const _hoisted_106 = { key: 0 }
const _hoisted_107 = ["for"]
const _hoisted_108 = ["value", "id"]
const _hoisted_109 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("h2", null, "Por responsável", -1)
const _hoisted_111 = { key: 2 }
const _hoisted_112 = ["for"]
const _hoisted_113 = ["value", "id"]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_115 = {
  key: 4,
  class: "no-responsibles"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z",
    stroke: "#949494",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3.40991 22C3.40991 18.13 7.25994 15 11.9999 15",
    stroke: "#949494",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.2 21.4C19.9673 21.4 21.4 19.9673 21.4 18.2C21.4 16.4327 19.9673 15 18.2 15C16.4327 15 15 16.4327 15 18.2C15 19.9673 16.4327 21.4 18.2 21.4Z",
    stroke: "#949494",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M22 22L21 21",
    stroke: "#949494",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("p", null, "Nenhum responsável encontrado", -1)
const _hoisted_118 = [
  _hoisted_116,
  _hoisted_117
]
const _hoisted_119 = /*#__PURE__*/_createElementVNode("h2", null, "Por assunto", -1)
const _hoisted_120 = { key: 5 }
const _hoisted_121 = ["for"]
const _hoisted_122 = ["value", "id"]
const _hoisted_123 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("h2", null, "Por tipo", -1)
const _hoisted_125 = ["for"]
const _hoisted_126 = ["id", "value", "onUpdate:modelValue"]
const _hoisted_127 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_128 = { class: "action" }
const _hoisted_129 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "52",
  height: "52",
  viewBox: "0 0 52 52",
  fill: "none"
}
const _hoisted_130 = /*#__PURE__*/_createElementVNode("path", {
  d: "M33.7569 42.6831C29.1852 43.0081 29.1852 49.6381 33.7569 49.9631H44.6119C45.9335 49.9631 47.1902 49.4865 48.1652 48.5981C51.3719 45.8031 49.6602 40.1698 45.4352 39.6498C43.9185 30.5065 30.6802 33.9731 33.8219 42.6831",
  fill: "#0071CF"
}, null, -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("path", {
  d: "M33.7569 42.6831C29.1852 43.0081 29.1852 49.6381 33.7569 49.9631H44.6119C45.9335 49.9631 47.1902 49.4865 48.1652 48.5981C51.3719 45.8031 49.6602 40.1698 45.4352 39.6498C43.9185 30.5065 30.6802 33.9731 33.8219 42.6831",
  fill: "#0071CF"
}, null, -1)
const _hoisted_132 = /*#__PURE__*/_createElementVNode("path", {
  d: "M47.6673 23.9847V33.2363C47.6673 33.9297 46.5623 34.233 46.0856 33.7347C45.0673 32.673 43.789 31.8713 42.3157 31.4163C38.914 30.3547 34.9923 31.3947 32.5223 33.9513C30.9623 35.6197 30.1173 37.6997 30.074 39.953C30.074 40.343 29.879 40.6897 29.5756 40.928C28.0156 42.163 27.0623 44.0913 27.0623 46.3013V46.323C27.0623 47.0163 26.564 47.6447 25.8706 47.6447H15.904C9.53398 47.6663 4.33398 42.4663 4.33398 36.0747V13.9097C4.33398 8.62301 8.62398 4.33301 13.9107 4.33301H18.9373C22.469 4.33301 23.574 5.48134 24.9823 7.36634L28.0156 11.3963C28.6873 12.2847 28.774 12.393 30.0306 12.393H36.0756C41.2323 12.393 45.609 15.773 47.104 20.453C47.429 21.428 47.6023 22.4247 47.6456 23.4863C47.6673 23.638 47.6673 23.833 47.6673 23.9847Z",
  fill: "#0071CF"
}, null, -1)
const _hoisted_133 = [
  _hoisted_130,
  _hoisted_131,
  _hoisted_132
]
const _hoisted_134 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_198_1747)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M9.29404 7.89904L15.5 1.68604C15.6857 1.50039 15.79 1.24859 15.79 0.986043C15.79 0.723492 15.6857 0.471695 15.5 0.286043C15.3144 0.100392 15.0626 -0.00390625 14.8 -0.00390625C14.5375 -0.00390625 14.2857 0.100392 14.1 0.286043L7.90004 6.49904L1.68604 0.289043C1.50039 0.103392 1.24859 -0.00090625 0.986043 -0.00090625C0.723492 -0.00090625 0.471695 0.103392 0.286043 0.289043C0.100392 0.474695 -0.00390625 0.726492 -0.00390625 0.989043C-0.00390625 1.25159 0.100392 1.50339 0.286043 1.68904L6.50004 7.89904L0.289043 14.107C0.103392 14.2927 -0.00090625 14.5445 -0.00090625 14.807C-0.00090625 15.0696 0.103392 15.3214 0.289043 15.507C0.474695 15.6927 0.726492 15.797 0.989043 15.797C1.25159 15.797 1.50339 15.6927 1.68904 15.507L7.90004 9.29304L14.108 15.499C14.2937 15.6847 14.5455 15.789 14.808 15.789C15.0706 15.789 15.3224 15.6847 15.508 15.499C15.6937 15.3134 15.798 15.0616 15.798 14.799C15.798 14.5365 15.6937 14.2847 15.508 14.099L9.29404 7.89904Z" })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_198_1747" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "15.794",
        height: "15.793",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_135 = [
  _hoisted_134
]
const _hoisted_136 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_137 = {
  key: 1,
  class: "dates"
}
const _hoisted_138 = { class: "transfer" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("h1", null, "Transferir documento", -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("strong", null, "(obrigatório)", -1)
const _hoisted_141 = ["id", "value", "onUpdate:modelValue"]
const _hoisted_142 = ["for"]
const _hoisted_143 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_388_3128)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z" })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_388_3128" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "12.5",
          height: "10",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("Responsável "),
  /*#__PURE__*/_createElementVNode("strong", null, "(obrigatório)")
], -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("h2", null, "Qual responsável agora precisa ter acesso a esse documento?", -1)
const _hoisted_146 = ["id", "checked", "value", "onUpdate:modelValue", "onChange"]
const _hoisted_147 = ["for"]
const _hoisted_148 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_388_3128)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z" })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_388_3128" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "12.5",
          height: "10",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_149 = ["disabled"]

import { computed, onMounted, ref, watch } from 'vue'
import MyModal from '@/components/modal/MyModal.vue'
import MyDatePicker from '@/components/date/MyDatePicker.vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import { UserModel } from '@/models/UserModel'
import DocumentStatusEnum, { documentStatusTranslations } from '@/enums/DocumentStatusEnum'
import { DocumentModel } from '@/models/DocumentModel'
import PaginationModel from '@/models/PaginationModel'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import router from '@/router'
import { useRoute } from 'vue-router'
import DocumentSubjectModel from '@/models/DocumentSubjectModel'
import { user } from '@/global/states/GlobalState'
import { OrganizationModel } from '@/models/OrganizationModel'
import MyOptions from '@/components/options/MyOptions.vue'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import { toast } from 'vue3-toastify'
import useDocument from '@/hooks/documents/useDocument'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'
import DocumentTypeEnum, { documentTypeTranslations } from '@/enums/DocumentTypeEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageDocuments',
  setup(__props) {

const axios = useAxios()
const isChamber = computed(() => user.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const isSuperAdmin = computed(() => user.value.hasRoles?.(['Super Admin']) ?? false)
const availableDocumentTypes = computed(() => {
  return (Object.values(DocumentTypeEnum) as DocumentTypeEnum[]).filter((type) => {
    return type !== DocumentTypeEnum.CIRCULAR || isSuperAdmin.value
  })
})
const documents = ref<PaginationModel<DocumentModel>>()
const users = ref<UserModel[]>()
const organizations = ref<OrganizationModel[]>()
const documentSubjects = ref<DocumentSubjectModel[]>()
const selectedDatesFilter = ref({ to: '', from: '' })
const isDateFilterModalOpen = ref<boolean>(false)
const isGlobalFiltersModalOpen = ref<boolean>(false)
const isMobileOptionsFilterOpen = ref<boolean>(false)
const selectedDocuments = ref<DocumentModel[]>([])
const route = useRoute()
const filter = ref<Partial<{status: DocumentStatusEnum, responsible_id: number, document_subject_id: number, organization_id: number, type: DocumentTypeEnum, from: string, to: string, search: string, order_by_created_at?: 'ASC' | 'DESC'}>>({ status: route.query.status as DocumentStatusEnum, type: route.query.type as DocumentTypeEnum })
const selectedDocument = ref<DocumentModel>()
const isConfirmCompleteDocumentModal = ref(false)
const isTransferDocumentModalOpen = ref(false)
const isUpdatingDocument = ref(false)
const updatePayload = ref<{ responsible?: UserModel, organization?: OrganizationModel, limit_date?: string }>({})

const { getAllowedUsersToTransfer, getAbilities, isDocumentOpen } = useDocument()
const isSelectedDocumentOpen = computed(() => selectedDocument.value ? isDocumentOpen(selectedDocument.value) : false)
const selectedDocumentAbilities = computed(() => getAbilities(user.value, selectedDocument.value))
const usersToTransfer = computed(() => getAllowedUsersToTransfer(user.value, selectedDocument.value, users.value, updatePayload.value.organization ? [updatePayload.value.organization] : undefined))
const tab = ref<'admin' | 'others'>('admin')
const documentsFromTab = computed(() => {
  if (tab.value === 'admin') {
    return documents.value?.data.filter((document) => {
      return !!document.logs.find((log) => {
        return !!log.responsibles.find((responsible) => responsible.id === user.value.id)
      }) || document.created_by === user.value.id
    })
  } else if (tab.value === 'others') {
    return documents.value?.data.filter((document) => {
      return !document.logs.find((log) => {
        return !!log.responsibles.find((responsible) => responsible.id === user.value.id)
      }) && document.created_by !== user.value.id
    })
  }

  return []
})

const toggleOverflow = () => {
  isMobileOptionsFilterOpen.value = !isMobileOptionsFilterOpen.value
  document.body.style.overflow = isMobileOptionsFilterOpen.value ? 'hidden' : 'auto'
}

const getDocuments = (page?: number) => {
  router.push({ query: page ? { ...route.query, page } : route.query })

  documents.value = undefined
  axios.get('/api/documents', { params: { ...filter.value, page: page } })
    .then((res: AxiosResponse<PaginationModel<DocumentModel>>) => {
      documents.value = res.data
    })
}

function updateOrderFilter(event: Event) {
  const target = event.target as HTMLInputElement
  filter.value.order_by_created_at = target.value as 'ASC' | 'DESC'
  getDocuments()
}

function getDocumentSubjects () {
  axios.get('/api/document-subjects')
    .then((res: AxiosResponse<DocumentSubjectModel[]>) => {
      documentSubjects.value = res.data.sort((a, b) => a.name.localeCompare(b.name))
    })
}

function getOrganizations (): void {
  axios.get('/api/organizations', { params: filter.value })
    .then((res: AxiosResponse<OrganizationModel[]>) => {
      organizations.value = res.data.sort((a, b) => a.name.localeCompare(b.name))
    })
}

function getUsers () {
  axios.get('/api/users')
    .then((res: AxiosResponse<UserModel[]>) => {
      users.value = res.data.sort((a, b) => a.name.localeCompare(b.name))
    })
}

function downloadFiles (documents: DocumentModel[]): void {
  documents.forEach((document) => {
    document.files.forEach((file) => {
      axios.get(`/api/documents/get-file-content/${file.id}`, { responseType: 'blob' })
        .then(response => {
          const url = URL.createObjectURL(new Blob([response.data]))

          const link = window.document.createElement('a')
          link.href = url
          link.setAttribute('download', file.name)
          link.style.display = 'none'
          window.document.body.appendChild(link)
          link.click()
          window.document.body.removeChild(link)
        })
        .catch(error => {
          console.error('Erro ao buscar o documento:', error)
        })
    })
  })
}

function getDaysDiff (firstDate: string, secondDate?: string): number {
  const date1 = new Date(firstDate)
  const date2 = secondDate ? new Date(secondDate) : new Date()

  const timeDifference = date1.getTime() - date2.getTime()

  const daysDifference = timeDifference / (1000 * 60 * 60 * 24)

  const roundedDaysDifference = Math.round(daysDifference)

  return roundedDaysDifference
}

function updateDocument (status?: DocumentStatusEnum): void {
  isUpdatingDocument.value = true

  if (status) {
    axios.patch(`/api/documents/${selectedDocument.value!.id}`, { status: status, limit_date: updatePayload.value.limit_date })
      .then((res: AxiosResponse<{document: DocumentModel}>) => {
        const index = documents.value!.data.findIndex((doc) => doc.id === res.data.document.id)
        if (index !== -1) {
          documents.value!.data[index] = res.data.document
        }
        selectedDocument.value = res.data.document
      }).finally(() => {
        isConfirmCompleteDocumentModal.value = false
        isUpdatingDocument.value = false
        toast.success(`Documento ${status == DocumentStatusEnum.UNDER_REVIEW ? 'reaberto' : 'finalizado'}`)
      })
  } else {
    const payload = updatePayload.value.responsible ? { responsible_ids: [updatePayload.value.responsible.id], organization_ids: [updatePayload.value.organization!.id] } : updatePayload.value
    axios.patch(`/api/documents/${selectedDocument.value!.id}`, payload)
      .then((res: AxiosResponse<{document: DocumentModel}>) => {
        const index = documents.value!.data.findIndex((doc) => doc.id === res.data.document.id)
        if (index !== -1) {
          documents.value!.data[index] = res.data.document
        }
        selectedDocument.value = res.data.document
        updatePayload.value = {}
      }).finally(() => {
        isTransferDocumentModalOpen.value = false
        isUpdatingDocument.value = false
        toast.success('Documento transferido')
      })
  }
}

onMounted(() => {
  getOrganizations()
  getUsers()
  getDocuments(route.query.page ? parseInt(route.query.page as string) : 0)
})

watch(isGlobalFiltersModalOpen, (open) => {
  if (open && !documentSubjects.value) {
    getDocumentSubjects()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin/home'))),
      class: "back"
    }, _hoisted_4),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          autocomplete: "off",
          type: "text",
          placeholder: "Digite sua busca",
          id: "search-doc",
          name: "search-doc",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.search) = $event)),
          onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (getDocuments()), ["prevent"]), ["enter"]))
        }, null, 544), [
          [_vModelText, filter.value.search]
        ]),
        (!filter.value.search)
          ? (_openBlock(), _createElementBlock("svg", {
              key: 0,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (getDocuments())),
              xmlns: "http://www.w3.org/2000/svg",
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none"
            }, _hoisted_8))
          : (_openBlock(), _createElementBlock("svg", {
              key: 1,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (filter.value.search = '')),
              xmlns: "http://www.w3.org/2000/svg",
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none"
            }, _hoisted_11))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          class: "tooltip",
          onClick: _cache[5] || (_cache[5] = ($event: any) => {isDateFilterModalOpen.value = true;})
        }, _hoisted_14),
        _createElementVNode("button", {
          class: "tooltip",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/admin/create-documents')))
        }, _hoisted_16),
        _createElementVNode("button", {
          class: "tooltip",
          onClick: _cache[7] || (_cache[7] = ($event: any) => {isGlobalFiltersModalOpen.value = true;})
        }, _hoisted_18),
        (documents.value?.data.length)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "tooltip",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (downloadFiles(documents.value.data)))
            }, _hoisted_20))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      (_unref(user).hasRoles!(['Super Admin']) || _unref(user).hasRoles!(['Presidente']))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['tab', tab.value])
          }, [
            _createElementVNode("h1", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (tab.value = 'admin'))
            }, "Administrador"),
            _createElementVNode("h1", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (tab.value = 'others'))
            }, "Outros " + _toDisplayString(isChamber.value ? 'câmaras' : 'setores'), 1),
            _hoisted_22
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("input", {
          type: "radio",
          name: "order-filter",
          id: "order-filter-asc",
          value: "DESC",
          onChange: updateOrderFilter,
          checked: ""
        }, null, 32),
        _createElementVNode("input", {
          type: "radio",
          name: "order-filter",
          id: "order-filter-desc",
          value: "ASC",
          onChange: updateOrderFilter
        }, null, 32),
        _hoisted_24,
        _hoisted_25
      ])
    ]),
    (documents.value && documents.value?.data.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("label", _hoisted_28, [
              _createElementVNode("input", {
                type: "checkbox",
                name: "all-docs",
                id: "all-docs",
                checked: selectedDocuments.value.length == documents.value.data.length,
                onChange: _cache[11] || (_cache[11] = ($event: any) => (($event.target as HTMLInputElement).checked ? selectedDocuments.value = documents.value.data.map((d) => d) : selectedDocuments.value = []))
              }, null, 40, _hoisted_29),
              _hoisted_30
            ]),
            _hoisted_31,
            _createElementVNode("label", null, [
              _createElementVNode("h1", null, _toDisplayString(isChamber.value ? 'Número de documento' : 'Ticket/ofício'), 1)
            ]),
            _hoisted_32,
            _hoisted_33,
            _hoisted_34,
            _hoisted_35
          ]),
          (selectedDocuments.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                (_openBlock(), _createElementBlock("svg", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => {selectedDocuments.value = [];}),
                  class: "close",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none"
                }, _hoisted_39)),
                _hoisted_40,
                _createElementVNode("h2", null, [
                  _createElementVNode("strong", null, _toDisplayString(selectedDocuments.value.length) + " itens foram selecionados", 1),
                  _createTextVNode(", oque deseja fazer com todos eles?")
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (downloadFiles(selectedDocuments.value)))
                  }, [
                    _hoisted_42,
                    (_openBlock(), _createElementBlock("svg", _hoisted_43, _hoisted_45))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(user).hasRoles!(['Super Admin']) || _unref(user).hasRoles!(['Presidente']) ? documentsFromTab.value : documents.value.data), (document) => {
            return (_openBlock(), _createElementBlock("div", {
              key: document.id,
              class: "documents-list doc-grid"
            }, [
              _createElementVNode("label", {
                for: `doc-${document.id}`,
                class: "check"
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  id: `doc-${document.id}`,
                  checked: selectedDocuments.value.find((d) => d.id == document.id) ? true : false,
                  onChange: ($event: any) => (selectedDocuments.value.find((d) => d.id == document.id) ? (selectedDocuments.value = selectedDocuments.value.filter((d) => document != d)) : selectedDocuments.value.push(document))
                }, null, 40, _hoisted_47),
                _hoisted_48
              ], 8, _hoisted_46),
              _createElementVNode("label", _hoisted_49, [
                _createElementVNode("h1", null, _toDisplayString(document.title), 1),
                _createElementVNode("h2", null, _toDisplayString(document.creator.organization?.name), 1)
              ]),
              _createElementVNode("label", null, [
                _createElementVNode("h1", null, _toDisplayString(document.physical_document_number), 1),
                _createElementVNode("h2", null, _toDisplayString(_unref(user).tenant?.acronym) + _toDisplayString(String(document.number).padStart(3, '0')), 1)
              ]),
              _createElementVNode("label", {
                class: _normalizeClass([{ late: false }, "date"])
              }, [
                _createElementVNode("h1", {
                  class: _normalizeClass(document.status != 'overdue' ? '':'text-red')
                }, _toDisplayString(new Date(document.limit_date).toLocaleDateString()), 3),
                (getDaysDiff(document.limit_date) > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50, "em " + _toDisplayString(getDaysDiff(document.limit_date)) + " dias", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("label", null, [
                (document.responsibles && document.responsibles.length)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_51, _toDisplayString(document.responsibles[0].name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("label", _hoisted_52, [
                _createElementVNode("div", {
                  class: _normalizeClass(["tag purple", document.status])
                }, _toDisplayString(_unref(documentStatusTranslations)[document.status]), 3),
                (document.is_exception)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createTextVNode(" exceção "),
                      _hoisted_54
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("label", _hoisted_55, [
                _createElementVNode("button", {
                  class: "tooltip",
                  onClick: ($event: any) => (_ctx.$router.push({ name: 'admin.documents.show', params: { id: document.id } }))
                }, _hoisted_58, 8, _hoisted_56),
                _createElementVNode("button", {
                  class: _normalizeClass([{active: true}, "options"]),
                  onClick: ($event: any) => (selectedDocument.value = document)
                }, [
                  _hoisted_60,
                  _createElementVNode("section", null, [
                    (isSelectedDocumentOpen.value && selectedDocumentAbilities.value.completeDocument)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          id: "confirm",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (isConfirmCompleteDocumentModal.value = true))
                        }, _hoisted_63))
                      : _createCommentVNode("", true),
                    (isSelectedDocumentOpen.value && selectedDocumentAbilities.value.transferDocument)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (isTransferDocumentModalOpen.value = true))
                        }, _hoisted_66))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      onClick: ($event: any) => (downloadFiles([document]))
                    }, _hoisted_70, 8, _hoisted_67),
                    (selectedDocumentAbilities.value.reopenDocument)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (isConfirmCompleteDocumentModal.value = true))
                        }, _hoisted_73))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_59)
              ])
            ]))
          }), 128)),
          (documents.value.links.length > 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value.links, (link, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    disabled: (index == 0 && !documents.value.prev_page_url) || (index == documents.value.links.length - 1 && !documents.value.next_page_url),
                    onClick: ($event: any) => (getDocuments(index != 0 && (index != documents.value.links.length - 1) ? parseInt(link.label) : (documents.value.current_page + (index ? 1 : -1)) )),
                    key: index,
                    class: _normalizeClass({active: link.active, passers: index == 0 || index == documents.value.links.length - 1})
                  }, _toDisplayString(link.label), 11, _hoisted_75))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : (documents.value && !documents.value.data.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
            _hoisted_77,
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$router.push('/admin/create-documents')))
              }, "Clique aqui"),
              _createTextVNode(" para cadastrar")
            ])
          ]))
        : (_openBlock(), _createBlock(SpinnerLoader, { key: 2 })),
    _createElementVNode("nav", {
      class: _normalizeClass([{active: isMobileOptionsFilterOpen.value}, "action-filters"]),
      onClick: _cache[27] || (_cache[27] = ($event: any) => (toggleOverflow()))
    }, [
      _createElementVNode("button", {
        onClick: [
          _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"])),
          _cache[19] || (_cache[19] = ($event: any) => {isDateFilterModalOpen.value = true; toggleOverflow();})
        ]
      }, _hoisted_80),
      _createElementVNode("button", {
        onClick: [
          _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"])),
          _cache[21] || (_cache[21] = ($event: any) => {_ctx.$router.push('/admin/create-documents'); toggleOverflow();})
        ]
      }, _hoisted_82),
      (documents.value?.data.length)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "tooltip",
            onClick: _cache[22] || (_cache[22] = ($event: any) => (downloadFiles(documents.value.data)))
          }, _hoisted_84))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: [
          _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"])),
          _cache[24] || (_cache[24] = ($event: any) => {isGlobalFiltersModalOpen.value = true; toggleOverflow();})
        ]
      }, _hoisted_86),
      (selectedDocuments.value.length)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: [
              _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"])),
              _cache[26] || (_cache[26] = ($event: any) => (downloadFiles(selectedDocuments.value)))
            ]
          }, _hoisted_88))
        : _createCommentVNode("", true),
      _hoisted_89
    ], 2),
    _createVNode(MyModal, {
      width: '700px',
      height: '634px',
      className: 'date-filter',
      isOpen: isDateFilterModalOpen.value,
      toggleModal: (v) => isDateFilterModalOpen.value = v,
      zIndex: 100
    }, {
      default: _withCtx(() => [
        _hoisted_90,
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("section", _hoisted_92, [
            _hoisted_93,
            _createVNode(MyDatePicker, {
              min: { day: 1, month: 1, year: 2024 },
              name: 'initial',
              setValue: (date) => selectedDatesFilter.value.from = date
            }, null, 8, ["setValue"])
          ]),
          _createElementVNode("section", _hoisted_94, [
            _hoisted_95,
            _createVNode(MyDatePicker, {
              min: { day: 1, month: 1, year: 2024 },
              name: 'final',
              setValue: (date) => selectedDatesFilter.value.to = date
            }, null, 8, ["setValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("input", {
            type: "button",
            value: "Filtrar",
            onClick: _cache[28] || (_cache[28] = ($event: any) => {filter.value.from = selectedDatesFilter.value.from; filter.value.to = selectedDatesFilter.value.to; getDocuments(); isDateFilterModalOpen.value = false;})
          }),
          _createElementVNode("input", {
            type: "button",
            value: "Cancelar",
            onClick: _cache[29] || (_cache[29] = ($event: any) => {isDateFilterModalOpen.value = false;})
          })
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"]),
    _createVNode(MyModal, {
      width: '554px',
      className: 'global-filters',
      isOpen: isGlobalFiltersModalOpen.value,
      toggleModal: (v) => isGlobalFiltersModalOpen.value = v,
      zIndex: 100
    }, {
      default: _withCtx(() => [
        _hoisted_97,
        _createElementVNode("div", _hoisted_98, [
          _hoisted_99,
          _createElementVNode("section", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DocumentStatusEnum), (status) => {
              return (_openBlock(), _createElementBlock("label", {
                for: status,
                key: status
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "by-stats",
                  id: status,
                  value: status,
                  "onUpdate:modelValue": ($event: any) => ((filter.value.status) = $event)
                }, null, 8, _hoisted_101), [
                  [_vModelRadio, filter.value.status]
                ]),
                _hoisted_102,
                _createElementVNode("p", null, _toDisplayString(_unref(documentStatusTranslations)[status]), 1)
              ], 8, _hoisted_100))
            }), 128)),
            _createElementVNode("label", _hoisted_103, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                name: "by-stats",
                id: "exception",
                value: "exception",
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((filter.value.status) = $event))
              }, null, 512), [
                [_vModelRadio, filter.value.status]
              ]),
              _hoisted_104,
              _hoisted_105
            ])
          ]),
          _createElementVNode("h2", null, "Por " + _toDisplayString(isChamber.value ? 'câmara' : 'setor'), 1),
          (organizations.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_106, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (org) => {
                  return (_openBlock(), _createElementBlock("label", {
                    for: org.name,
                    key: org.id
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "organization_id",
                      value: org.id,
                      id: org.name,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((filter.value.organization_id) = $event))
                    }, null, 8, _hoisted_108), [
                      [_vModelRadio, filter.value.organization_id]
                    ]),
                    _hoisted_109,
                    _createElementVNode("p", null, _toDisplayString(org.name), 1)
                  ], 8, _hoisted_107))
                }), 128))
              ]))
            : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 })),
          _hoisted_110,
          (users.value && users.value.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_111, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                  return (_openBlock(), _createElementBlock("label", {
                    for: user.name + user.id,
                    key: user.id
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "by-responsible",
                      value: user.id,
                      id: user.name + user.id,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((filter.value.responsible_id) = $event))
                    }, null, 8, _hoisted_113), [
                      [_vModelRadio, filter.value.responsible_id]
                    ]),
                    _hoisted_114,
                    _createElementVNode("p", null, _toDisplayString(user.name), 1)
                  ], 8, _hoisted_112))
                }), 128))
              ]))
            : (!users.value)
              ? (_openBlock(), _createBlock(SpinnerLoader, { key: 3 }))
              : (_openBlock(), _createElementBlock("section", _hoisted_115, _hoisted_118)),
          _hoisted_119,
          (documentSubjects.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_120, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentSubjects.value, (subject) => {
                  return (_openBlock(), _createElementBlock("label", {
                    for: subject.name,
                    key: subject.id
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "document_subject_id",
                      value: subject.id,
                      id: subject.name,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((filter.value.document_subject_id) = $event))
                    }, null, 8, _hoisted_122), [
                      [_vModelRadio, filter.value.document_subject_id]
                    ]),
                    _hoisted_123,
                    _createElementVNode("p", null, _toDisplayString(subject.name), 1)
                  ], 8, _hoisted_121))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _hoisted_124,
          _createElementVNode("section", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDocumentTypes.value, (type) => {
              return (_openBlock(), _createElementBlock("label", {
                for: `filter-type-${type}`,
                key: type
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "type",
                  id: `filter-type-${type}`,
                  value: type,
                  "onUpdate:modelValue": ($event: any) => ((filter.value.type) = $event)
                }, null, 8, _hoisted_126), [
                  [_vModelRadio, filter.value.type]
                ]),
                _hoisted_127,
                _createElementVNode("p", null, _toDisplayString(_unref(documentTypeTranslations)[type]), 1)
              ], 8, _hoisted_125))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_128, [
          _createElementVNode("input", {
            type: "button",
            value: "Filtrar",
            onClick: _cache[34] || (_cache[34] = ($event: any) => {getDocuments(); isGlobalFiltersModalOpen.value = false;})
          }),
          _createElementVNode("input", {
            type: "button",
            value: "Limpar",
            onClick: _cache[35] || (_cache[35] = ($event: any) => {filter.value = {}; getDocuments(); isGlobalFiltersModalOpen.value = false;})
          })
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"]),
    (selectedDocument.value)
      ? (_openBlock(), _createBlock(MyModal, {
          key: 3,
          width: '330px !important',
          height: !isSelectedDocumentOpen.value && new Date(selectedDocument.value.limit_date).getTime() < new Date().getTime() ? '517px !important' : '299px !important',
          isOpen: isConfirmCompleteDocumentModal.value,
          "class-name": !isSelectedDocumentOpen.value && new Date(selectedDocument.value.limit_date).getTime() < new Date().getTime() ? 'confirm-complete-document picker' : 'confirm-complete-document',
          toggleModal: (v) => isConfirmCompleteDocumentModal.value = v,
          zIndex: 100
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (isSelectedDocumentOpen.value || !(!isSelectedDocumentOpen.value && new Date(selectedDocument.value.limit_date).getTime() < new Date().getTime()))
                ? (_openBlock(), _createElementBlock("svg", _hoisted_129, _hoisted_133))
                : _createCommentVNode("", true),
              _createElementVNode("h1", {
                style: _normalizeStyle(!isSelectedDocumentOpen.value && new Date(selectedDocument.value.limit_date).getTime() < new Date().getTime() ? 'justify-content: space-between;' : '')
              }, [
                _createTextVNode(_toDisplayString(!isSelectedDocumentOpen.value ? 'Reabrir' : 'Concluir') + " processo ", 1),
                (!isSelectedDocumentOpen.value && new Date(selectedDocument.value.limit_date).getTime() < new Date().getTime())
                  ? (_openBlock(), _createElementBlock("figure", {
                      key: 0,
                      onClick: _cache[36] || (_cache[36] = ($event: any) => (isConfirmCompleteDocumentModal.value = false))
                    }, _hoisted_135))
                  : _createCommentVNode("", true)
              ], 4),
              _createElementVNode("h2", {
                style: _normalizeStyle(!isSelectedDocumentOpen.value && new Date(selectedDocument.value.limit_date).getTime() < new Date().getTime() ? 'text-align: start;' : '')
              }, [
                _createTextVNode("Quer mesmo " + _toDisplayString(!isSelectedDocumentOpen.value ? 'reabrir' : 'concluir') + " esse processo? ", 1),
                _hoisted_136,
                _createTextVNode(" " + _toDisplayString(isSelectedDocumentOpen.value ? 'Após conclusão só será possível novas interações se o documento for reaberto.' : '') + " " + _toDisplayString(!(!isSelectedDocumentOpen.value && new Date(selectedDocument.value.limit_date).getTime() < new Date().getTime()) && !isSelectedDocumentOpen.value ? 'Após conclusão já será possível ser feita novas interações.' : ''), 1)
              ], 4),
              (!isSelectedDocumentOpen.value && new Date(selectedDocument.value.limit_date).getTime() < new Date().getTime())
                ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                    _createVNode(MyDatePicker, {
                      min: { day: new Date().getDate(), month: new Date().getMonth() + 1, year: new Date().getFullYear() },
                      setValue: (v) => updatePayload.value.limit_date = v,
                      name: "limit"
                    }, null, 8, ["min", "setValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", null, [
                (!isUpdatingDocument.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[37] || (_cache[37] = ($event: any) => (updateDocument(!isSelectedDocumentOpen.value ? _unref(DocumentStatusEnum).UNDER_REVIEW : _unref(DocumentStatusEnum).COMPLETED)))
                    }, "Sim"))
                  : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                      key: 1,
                      isButton: false
                    })),
                _createElementVNode("input", {
                  onClick: _cache[38] || (_cache[38] = ($event: any) => {isConfirmCompleteDocumentModal.value = false;}),
                  type: "button",
                  value: "Cancelar"
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["height", "isOpen", "class-name", "toggleModal"]))
      : _createCommentVNode("", true),
    _createVNode(MyModal, {
      width: '776px',
      height: '1171px',
      isOpen: isTransferDocumentModalOpen.value,
      "class-name": 'transfer-document',
      toggleModal: (v) => isTransferDocumentModalOpen.value = v,
      zIndex: 100
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_138, [
          _hoisted_139,
          _createElementVNode("h1", null, [
            _createTextVNode(_toDisplayString(isChamber.value ? 'Câmara' : 'Setor') + " ", 1),
            _hoisted_140
          ]),
          _createElementVNode("h2", null, "Qual " + _toDisplayString(isChamber.value ? 'câmara' : 'setor') + " agora precisa ter acesso a esse documento?", 1),
          _createVNode(MyOptions, {
            currentValue: updatePayload.value.organization?.name ?? 'Selecione'
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (organization, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: index
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: 'organizations-transfer-modal-' + index,
                    name: "organizations-transfer-modal",
                    value: organization,
                    "onUpdate:modelValue": ($event: any) => ((updatePayload.value.organization) = $event),
                    onChange: _cache[39] || (_cache[39] = ($event: any) => (($event.target as HTMLInputElement).checked ? (updatePayload.value.responsible = undefined) : ''))
                  }, null, 40, _hoisted_141), [
                    [_vModelRadio, updatePayload.value.organization]
                  ]),
                  _createElementVNode("label", {
                    for: 'organizations-transfer-modal-' + index
                  }, [
                    _hoisted_143,
                    _createElementVNode("p", null, _toDisplayString(organization.name), 1)
                  ], 8, _hoisted_142)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["currentValue"]),
          _hoisted_144,
          _hoisted_145,
          _createVNode(MyOptions, {
            currentValue: updatePayload.value?.responsible?.name ? `${updatePayload.value.responsible.name} ${updatePayload.value.responsible.last_name ?? ''}` : 'Selecione'
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersToTransfer.value, (responsible, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: index
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: 'responsible-transfer-modal-' + index,
                    name: "responsible-transfer-modal",
                    checked: updatePayload.value.responsible?.id == responsible.id,
                    value: responsible,
                    "onUpdate:modelValue": ($event: any) => ((updatePayload.value.responsible) = $event),
                    onChange: ($event: any) => (($event.target as HTMLInputElement).checked ? (updatePayload.value.organization = updatePayload.value.responsible?.organization) : '')
                  }, null, 40, _hoisted_146), [
                    [_vModelRadio, updatePayload.value.responsible]
                  ]),
                  _createElementVNode("label", {
                    for: 'responsible-transfer-modal-' + index
                  }, [
                    _hoisted_148,
                    _createElementVNode("p", null, _toDisplayString(responsible.name) + " " + _toDisplayString(responsible.last_name), 1)
                  ], 8, _hoisted_147)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["currentValue"])
        ]),
        _createElementVNode("nav", null, [
          (!isUpdatingDocument.value)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "button",
                value: "Enviar",
                onClick: _cache[40] || (_cache[40] = ($event: any) => (updateDocument())),
                disabled: !updatePayload.value.responsible || !updatePayload.value.organization
              }, null, 8, _hoisted_149))
            : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                key: 1,
                height: 60,
                maxWidth: 464
              })),
          _createElementVNode("input", {
            type: "button",
            value: "Cancelar",
            onClick: _cache[41] || (_cache[41] = ($event: any) => (isTransferDocumentModalOpen.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"])
  ]))
}
}

})